import dynamic from 'next/dynamic';
import LoaderPage from '@/reactPages/LoaderPage/LoaderPage';

export const HomeApplication = dynamic(() => import('./HomeApplication'), {
  ssr: false,
  loading: () => <LoaderPage/>,
});
